import  { useEffect, useState } from 'react'
import { Descriptions, Modal} from 'antd';
import { useBnsBanBenUpdateQuery } from '../../store/BnsKeJiApi';
function SubmoduleCheck(props) {
    const [open,setOpen] = useState(false)
    const [info,setInfo] = useState({
            ebn_team_num:'',
        })
        const {data,isSuccess} = useBnsBanBenUpdateQuery({bbb_id:props.bbb_id},{skip:!open})
        useEffect(() => {
            if(isSuccess){
                if(data.Status==='success'){
                    setInfo({
                        bbb_name:data.Result.bbb_name,                  
                        bbb_bg_name:data.Result.bbb_bg_name,                  
                        bbb_bgn_name:data.Result.bbb_bgn_name,                  
                        bbb_bg_id:data.Result.bbb_bg_id,                  
                        bbb_xuzhi:data.Result.bbb_xuzhi,                  
                        bbb_jihua:data.Result.bbb_jihua,                  
                        bbb_dept_id:data.Result.bbb_dept_id,                  
                        bbb_content:data.Result.bbb_content,                  
                        bbb_dept_name:data.Result.bbb_dept_name,                                        
                        bbb_cname:data.Result.bbb_cname,                                        
                        bbb_ctime:data.Result.bbb_ctime,                                        
                    })
                    // console.log(array);
                    
                }
            }
        },[data, isSuccess])
        const items = [
            {
                key:'bbb_bg_name',
                label:'项目名称',
                children:<div dangerouslySetInnerHTML={{__html:info.bbb_bg_name}}></div>,
                contentStyle:{fontSize:"14px"},
                span:3,
            },          
            {
                key:'bbb_bgn_name',
                label:'模块名称',
                children:<div dangerouslySetInnerHTML={{__html:info.bbb_bgn_name}}></div>,
                contentStyle:{fontSize:"14px"},
                span:3,
            },          
            {
                key:'bbb_name',
                label:'子模块名称',
                children:<div dangerouslySetInnerHTML={{__html:info.bbb_name}}></div>,
                contentStyle:{fontSize:"14px"},
                span:3,
            },          
            {
                key:'bbb_name',
                label:'模块说明',
                children:<div dangerouslySetInnerHTML={{__html:info.bbb_xuzhi}}></div>,
                contentStyle:{fontSize:"14px"},
                span:3,
            },          
            {
                key:'bbb_dept_name',
                label:'部门',
                children:<>{info.bbb_dept_name}</>,
                contentStyle:{fontSize:"14px"},
                span:3,
            },
            {
                key:'bbb_ctime',
                label:'新增时间',
                children:info.bbb_ctime+info.bbb_cname,
                contentStyle:{fontSize:"14px"},
                span:3,
            },
        ]
    return (
        <>
            <a onClick={() => {setOpen(true)}}>{props.bbb_name}</a>
            <Modal
                open={open}
                okText="提交"
                cancelText="取消"
                onCancel={() => {
                    setOpen(false);
                }}
                onOk={() => {}}
                footer={null}
                width={800}
                title='查看子模块'
            >            
                <Descriptions
                    items={items}
                    bordered
                />
            </Modal>
        </>
    )
}

export default SubmoduleCheck